export const domainName = {
    frontend: 'https://act-frontend.ascendtravel.com',
    backend: 'https://act-backend.ascendtravel.com',
    service: 'https://api.ascendtravel.com',
};
export const configFlight = {
    displayFlight: true,
    clientId: 'traveligo',
    redirectURI: 'https://corporate.traveligo.com/account/generate-code'
};
export const configCarRental = {
    displayCarRental: true,
    clientId: 'rentConnected',
    redirectURI: 'https://www.rentconnected.com/external/AscendLogin'
};
export const configB2C = {
    clientId: '3',
};
export const disableHome = true;
export const useHomeV2 = true;
export const disableHotelList = true;
export const useHotelListV2 = true;
export const disableHotelDetail = true;
export const useHotelDetailV2 = true;
export const redirectURIV2 = 'https://hotel.ascendtravel.com';

export const publicKey = 'https://s3-ap-northeast-1.amazonaws.com/ascendtravel-authentication-keys-prod/access_publickey.cer';
export const googleTagManagerId = 'GTM-PL3LW4DL'
export const googleTagManagerAuth = '6G9XCEUrTLHKzNwSxFddKg'
export const googleTagManagerPreview = 'env-1'
export const googleMapKey = 'AIzaSyDFz9J6xoeuEUW5SZUmu21oYZ0CHzvYUBo';
export const productionMode = true;
export const hotjarId = 1193934;
export const imgUrl = 'https://s3-ap-southeast-1.amazonaws.com/ascendtravel-image';
export const resizeImageGateway = 'https://api-gateway.ascendtravel.com';
export const redirectURI = 'https://www.ascendtravel.com/redirect';
export const accountFrontend = 'https://account.ascendtravel.com/login';
export const frontend = 'https://www.ascendtravel.com';
export const travelTogether = 'https://traveltogether.ascendtravel.com';
export const asq = 'https://asq.ascendtravel.com';
export const imageURI = 'https://images.ascendtravel.com';
export const domain = '.ascendtravel.com';
export const prefixCookieName = 'act';
export const onetrustDataDomainScript = '01913111-d877-7309-b285-2d887b5809fa';
export const clarityKey = '5fzf2o7ger';
export const consentName = 'act';
export const cookiesConsentName = 'cookies';
export const reCaptchaSiteKey = '6LcY6AAbAAAAAErYiOifjkZSURh4N8pineRfDbpv';
export const envName = 'prod';
export const sentryKey = 'https://191a9407eaa0468396cb8130bbebec23@o949524.ingest.sentry.io/5898276';
export const effectiveDateNewTaxAddress = '01-12-2021 00:00';
export const landingUrl = 'https://landing.ascendtravel.com';
export const thresholdExpireToken = 300000;
export const maintenanceSite = 'https://close.ascendtravel.com/act-maintenance';



// WEBPACK FOOTER //
// ./src/environments/properties.ts